exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-modal{transition:box-shadow 1s}.error-modal.has-bugs{box-shadow:0 24px 80px -2px rgba(255,0,0,.6)!important}.error-modal-content{padding:10px;text-align:center}.error-modal-content .bugs-label{text-transform:uppercase;font-size:60px;font-weight:300;letter-spacing:2px;padding:40px}.error-modal-content button{width:180px}.error-modal-content sub{color:#ec625f;transition:opacity .25s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-c8610f30","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/DemoErrorModal.vue
// module id = 18
// module chunks = 0